<template>
  <v-card class="tn-panel">
    <div class="tn-panel__head">
      <v-icon size="20">mdi-account-multiple-outline</v-icon> Travellers
      <span v-if="travellers.length" class="tn-muted ml-1">({{ travellers.length }})</span>
    </div>
    <v-simple-table v-if="travellers.length" class="tn-travellers">
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Gender</th>
          <th>Birth date</th>
          <th>Passport</th>
          <th>Country</th>
          <th>Passport expiry</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in travellers" :key="item.id || i">
          <td class="font-weight-medium">{{ fullName(item) }}</td>
          <td>{{ typeLabel(item.passengerType) }}</td>
          <td>{{ item.passengerGender || '—' }}</td>
          <td class="text-no-wrap">{{ date(item.date_of_birth) }}</td>
          <td>{{ item.passport_number || '—' }}</td>
          <!-- passport issuer on the website; nationality on app bookings -->
          <td>{{ item.passport_issue_country || '—' }}</td>
          <td class="text-no-wrap">{{ date(item.passport_expire_date) }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <div v-else class="tn-panel__body">
      <p class="tn-muted mb-0">{{ emptyText }}</p>
    </div>
  </v-card>
</template>

<script>
import { formatDate } from '../../utils/format'

export default {
  name: 'TravellersPanel',
  props: {
    travellers: { type: Array, default: () => [] },
    emptyText: { type: String, default: 'No traveller details were entered for this booking.' }
  },
  methods: {
    fullName (item) {
      return [item.passengerTitle, item.passengerFirstName, item.passengerLastName].filter(Boolean).join(' ') || '—'
    },
    typeLabel (type) {
      const t = String(type || '').toUpperCase()
      if (t === 'CHD' || t === 'CHILD') return 'Child'
      if (t === 'INF' || t === 'INFANT') return 'Infant'
      return 'Adult'
    },
    date (value) {
      return value ? formatDate(value) : '—'
    }
  }
}
</script>
